export const isClient = () => typeof window !== 'undefined' && !!window.location;
